import React, { useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { leaveOrg, leaveTeam } from "../../../api/UserAPI";
import {
  ActionIcon,
  Button,
  Group,
  Modal,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconDoorExit } from "@tabler/icons-react";
import BackButton from "../../../components/View/BackButton";

const LeaveCommunity = ({ isOrg, current, setTableLoading }) => {
  const lang = useLanguage((s) => s.language);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    let func = isOrg ? leaveOrg : leaveTeam;
    func(current.id)
      .then(() => {
        handleClose();
        setTableLoading(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      <Tooltip label={lang[isOrg ? "organizations" : "teams"].leave.label}>
        <ActionIcon
          variant="subtle"
          onClick={() => {
            handleOpen();
          }}
          color="red"
        >
          <IconDoorExit size={18} />
        </ActionIcon>
      </Tooltip>

      <Modal
        opened={open}
        onClose={handleClose}
        size={"md"}
        title={
          <>
            {lang[isOrg ? "organizations" : "teams"].leave.dialog.title} : {current?.name} #{current?.id}
          </>
        }
      >
        <Stack>
          <Text>{lang[isOrg ? "organizations" : "teams"].leave.dialog.text}</Text>

          <Group mt={"md"} justify="end">
            <BackButton onClick={handleClose} size="md" />

            <Button onClick={onSubmit} loading={loading} size="md" color="red">
              {lang[isOrg ? "organizations" : "teams"].leave.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default LeaveCommunity;
